import React from "react";
import styles from "./PhotographerCard.module.css";
// import Images from "../../All_Images/Images";


import PhotographerBanner from "./PhotographerBanner";

const PhotographerCard = (props) => {
  return (
    <div className={styles["card-container"]}>
      <div className={styles["image-slider__container"]}>
        {/* <div className={styles["image-box"]}>
          {props.displayImages.map((image, id) => (
            <div className={styles["image"]}>
              <img src={image} key={id} alt="" />
            </div>
          ))}
        </div> */}
        <div className={styles["image-box"]}>
          <PhotographerBanner displayImages={props.displayImages}/>
        </div>
        {/* </div> */}
        {/* <div className={styles["upper-container"]}> */}
      </div>
      <div className={styles["image-container"]}>
        <img
          onContextMenu={(e)=>{e.preventDefault()}}
          className={styles["image-container__img"]}
          src={props.image_url} alt=""
        />
      </div>
      <div className={styles["lower-container"]}>
        <div>
          <h3>{props.name}</h3>
          <h4>{props.location}</h4>
        </div>
        <div className={styles["p_intro-container"]}>
          <p className={styles["p_intro"]}>{props.intro}</p>
        </div>
      </div>
      {/* <div className={styles["photographer_cta"]}>
        <a className="btn btn-primary" href="tel:07020147576">Call Now</a>
        <a className="btn btn-primary" onClick={() => props.setPopupDisplay(true)}>Make a request</a>
      </div> */}
    </div>
  );
};

export default PhotographerCard;
